
import { useCallback, useState, useEffect, useMemo, useRef, startTransition } from "react";
import { CopyOutlined, DeleteOutlined, DownloadOutlined, HomeOutlined, InboxOutlined, ReloadOutlined, PrinterOutlined, ArrowDownOutlined, ArrowUpOutlined, ArrowLeftOutlined, ArrowRightOutlined, MoreOutlined, TrophyOutlined, CaretLeftOutlined } from "@ant-design/icons"
import { Flex, message, Button, Form, Modal, Table, Popover, Divider, Collapse } from "antd"
import TextArea from "antd/es/input/TextArea";
import { useLocation, useParams } from "react-router-dom";
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js";
import "../../style/requests.css"
import { downloadRequestXml, getDuplicateCheckList, getSingleRequest, getSpaceAllFormsByWorkflowId, submitRequestForm } from "../../services/requestServices";
import RequestForm from "./RequestForm";
import { getAllFormConditionForWorkflow, getSpaceWorkflow, getWorkflowConditions } from "../../services/WorkflowServices";
import { showLoader } from "../../utils/showloader";
import RequestDetails from "./RequestDetails";
import { useSelector } from "react-redux";
import moment from "moment";
import { approvalDelayed, flattenScoreTree, formatPostValue, formConditionsHandler, getAllWidgets, getContrastTextColor, getCurrentWorkflowForms, getDelegatedUser, getDueDate, getHighlightAction, isScoreBasedCondition } from "../../utils/formsHelper";
import { buildSkippedStepData, canSendStepWaitingNotification, getDifferenceValues, getRequestApprovers, getShowApprovalTab, getShowRequesterSaveButton, getStepApprovers, getStepFormValues, getUniqueStepUsers, getVisibleWidgets, hasUserActedOnCurrentStep, hideApprovalStatus, isObjectEmpty, isValidDate, nodeConditionsHandler } from "../../utils/requestHelper";
import { safeDayjs } from "../../utils/safeDate.js";
import { trimStringValues } from "../../utils/trimStrings";
import { getStoredCompanyIdentifier } from "../../utils/companyIdentifier";
import { spaceColorBgMapping } from "../../utils/colorBgColorMap";
import SubmitMessage from "./SubmitMessage";
import { useDispatch } from "react-redux";
import { getSpaceNotification } from "../../services/notificationServices";
import { triggerNotification } from "./triggerNotification";
import BreadCrumb from "../BreadCrumb";
import { getCurrentSpaceData, getUserSpaceEntitlements } from "../../utils/currentUserDetail";
import { sortNodesByEdges } from "../../utils/workflowHelper";
import dayjs from "dayjs";
import { createOutlookEventData } from "../../utils/paymentScheduleGenerator.js";
import { getMasterList } from "../../services/adminServices";
import { setMasterList as setMasterListRedux } from "../../redux/slices/masterDataSlice";
import { useTranslation } from "react-i18next";
import { printRequestDocument } from "../../utils/requestPrint";

const EMPTY_OBJ = {};

const Requests = () => {
    const navigate = useTenantNavigation();
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const [spaceForms, setSpaceForms] = useState([])
    const [activeForms, setActiveForms] = useState([])
    const [currentActiveForms, setCurrentActiveForms] = useState([])
    const { spaceId, workflowId, mode, requestId } = useParams()
    const [currentActiveForm, setCurrentActiveForm] = useState({})
    const [formConditions, setFormConditions] = useState([])
    const [workflowData, setWorkflowData] = useState({})
    const [requestDetail, setRequestDetail] = useState({})
    const [defaultRequestDetail, setDefaultRequestDetail] = useState({})
    const [requesterNode, setRequesterNode] = useState({})
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [docIsSubmitting, setDocIsSubmitting] = useState(false)
    const [workflowConditions, setWorkflowConditions] = useState([])
    const [messageState, setMessageState] = useState(false)
    const [currentStatus, setCurrentStatus] = useState("")
    const [currentValues, setCurrentValues] = useState({})
    const currentValuesRef = useRef({})
    const saveGenerationRef = useRef(0)
    const [notificationTemplates, setNotificationTemplates] = useState([])
    const { spaceSpecificUserPickers = [], spaceSpecificUsers = [], spaceSpecificGroups = [] } = useSelector((state) => state.userRoleGroupState)
    const [requestForm] = Form.useForm();
    const [breadcrumbs, setBreadCrumbs] = useState([])
    const [archiveDeleteAction, setArchiveDeleteAction] = useState("")
    const [archiveDeleteModal, setArchiveDeleteModal] = useState(false)
    const [checkDuplicate, setCheckDuplicate] = useState(false)
    const [duplicatesList, setDuplicatesList] = useState([])
    const [duplicateColumns, setDuplicateColumns] = useState([])
    const [duplicateValues, setDuplicateValues] = useState([])
    const [showDuplicateCheckModal, setShowDuplicateCheckModal] = useState(false)
    const [selectedDuplicateData, setSelectedDuplicateData] = useState(null)
    const [okToProceed, setOkToProcess] = useState(false)
    const [currentRequestId, setCurrentRequestId] = useState(requestId)
    const [approvedStatus, setApprovedStatus] = useState("")
    const [workflowLoaded, setWorkflowLoaded] = useState(false)
    const [formConditionsLoaded, setFormConditionsLoaded] = useState(false)
    const [workflowConditionsLoaded, setWorkflowConditionsLoaded] = useState(false)
    const [draftAutoSaved, setDraftAutoSaved] = useState(false)
    const [isDetailsOpen, setIsDetailsOpen] = useState(true)
    const [isMobileView, setIsMobileView] = useState(typeof window !== "undefined" && window.innerWidth <= 768)
    const [actionsPopoverOpen, setActionsPopoverOpen] = useState(false)
    const [showScoreModal, setShowScoreModal] = useState(false)
    const requestFromMobile = new URLSearchParams(window.location.search).get("type") === "mobile"

    const [commentForm] = Form.useForm();

    const { userInfo, userGroups, userGroupSpaces } = useSelector(state => state.user)
    const { limits } = useSelector(state => state.plan)
    // Master backed fields store row uuids; the print resolves them to names with
    // the same list the dropdowns read.
    const { masterList } = useSelector(state => state.masterData)
    // Both build a fresh object on every call and are passed straight into RequestForm,
    // so without these the memo on it can never hold.
    const spaceEntitlements = useMemo(
        () => getUserSpaceEntitlements(spaceId, userInfo.userAccess, userGroupSpaces),
        [spaceId, userInfo.userAccess, userGroupSpaces])
    // i18n.language is a real dependency: getCurrentSpaceData localises name/description.
    const spaceData = useMemo(
        () => getCurrentSpaceData(spaceId, userInfo.spaceInfo, userGroupSpaces) || EMPTY_OBJ,
        [spaceId, userInfo.spaceInfo, userGroupSpaces, i18n.language])
    let showApprovalTab = getShowApprovalTab(requestDetail, userInfo, userGroups) || false
    const showRequesterSaveButton = getShowRequesterSaveButton(requesterNode, defaultRequestDetail, userInfo)
    const hasSubmittedCurrentStep = hasUserActedOnCurrentStep(defaultRequestDetail, userInfo)
    let isCurrentSpaceAdmin = userInfo.isAdmin ? true : false
    // if (spaceId && userInfo && userInfo.userAccess) {
    //     let foundSpace = userInfo.userAccess.find(r => r.resource == spaceId)
    //     if (foundSpace && (foundSpace.role == "Admin" || foundSpace.role == "admin")) {
    //         isCurrentSpaceAdmin = true
    //     }
    // }

    // Check if PlanLimitBanner is visible (same logic as header.jsx)
    const BANNER_HEIGHT = 44;
    const isHeaderHidden = new URLSearchParams(window.location.search).get("type") === "mobile";
    const HEADER_HEIGHT = isHeaderHidden ? 0 : 64;
    const REQUEST_HEADER_HEIGHT = 64;
    const currentSpacesCount = userInfo?.spaceInfo?.length || 0;
    const spacesLimit = limits?.spaces || 0;
    const isSpacesLimitReached = spacesLimit > 0 && currentSpacesCount >= spacesLimit;
    const isBannerVisible = !isHeaderHidden && userInfo?.isAdmin && isSpacesLimitReached;
    const headerOffset = isBannerVisible ? HEADER_HEIGHT + BANNER_HEIGHT : HEADER_HEIGHT;
    const requestDetailsTop = headerOffset + REQUEST_HEADER_HEIGHT;

    useEffect(() => {
        showLoader(true)
    }, [])

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsDetailsOpen(false)
        }
    }, [])

    useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth <= 768)
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(() => {
        if (requestId === "new") {
            setWorkflowLoaded(false)
            setFormConditionsLoaded(false)
            setWorkflowConditionsLoaded(false)
            setDraftAutoSaved(false)
        }
    }, [requestId, workflowId])

    useEffect(() => {
        if (spaceData && spaceData.spaceId) {
            const breadCrumbItems = [
                {
                    title: <HomeOutlined />,
                    path: userInfo.isAdmin ? "/app/dashboard" : "/app/dashboard",
                },
                {
                    title: spaceData.name,
                    path: `/app/space/${spaceId}/documents`
                },
                {
                    title: defaultRequestDetail?.caseId || "New Request",
                },
            ];
            setBreadCrumbs(breadCrumbItems)
        }
    }, [spaceData, currentActiveForm, defaultRequestDetail])

    const getRequestDetail = async () => {
        showLoader(true);
        const response = await getSingleRequest(requestId);

        if (response.status === 200 && response.data) {
            setDefaultRequestDetail(response.data)
            setRequestDetail(response.data)
            let requestData = response.data
            let approvedStatusLabel = requestData.originalWorkflow?.nodes?.find(node => node.data?.type === "end" && node.data?.name === requestData.status)?.data?.name || ""
            setApprovedStatus(approvedStatusLabel)
            let currentWorkflowValue = requestData.originalWorkflow?.nodes.find(node => node?.data?.name === response.data.status)
            if (!currentWorkflowValue) {
                currentWorkflowValue = requestData.originalWorkflow?.nodes?.find(node => node?.type === "default")
            }
            setCurrentStatus(currentWorkflowValue?.id || "")
            setWorkflowData({ workflowId: workflowId, node: requestData.originalWorkflow?.nodes, edge: requestData.originalWorkflow?.edges })
            setFormConditions(requestData.formConditions || [])
            setWorkflowConditions(requestData.workflowConditions || [])
            setSpaceForms(requestData.workflowForms || [])
            let workflowHasDuplicateCheck = requestData.originalWorkflow?.nodes.find(node => node?.data?.type === "duplicateCheck")
            setCheckDuplicate(workflowHasDuplicateCheck ? true : false)
            let requestForms = []
            if (requestData.status !== "draft" && requestData?.workflow?.length > 0) {
                requestForms = getCurrentWorkflowForms(requestData.workflowForms, requestData.originalWorkflow.nodes, requestData.status, requestData.workflow, requestData.currentCycle, requestData.currentCycle)
                if (requestForms.length === 0) {
                    requestForms = requestData.workflowForms[0] ? [requestData.workflowForms[0]] : []
                }

            } else {
                let defaultNode = requestData.originalWorkflow?.nodes.find(node => node.type === "default")
                let requesterForm = requestData.workflowForms?.find(form => form.nodeId === defaultNode.id)
                if (requesterForm) {
                    requestForms = [requesterForm]
                }
                let initiatorNode = requestData.originalWorkflow.nodes.find(node => node.type === "default")
                setRequesterNode(initiatorNode || {})
            }
            if (requestData.status?.toLowerCase() === approvedStatusLabel) {
                setActiveForms(requestForms)
            } else {
                let currentForm = currentWorkflowValue?.formData?.formId ? requestForms.find(form => form.formId === currentWorkflowValue.formData.formId) : {}
                setCurrentActiveForm(currentForm || {})
                requestForms = requestForms.filter(form => form.formId)
                if (requestData.status !== "closed" && requestData.status !== "archived" && requestData.status !== "deleted" && requestData.status !== "rejected" && currentForm && requestData?.workflow?.length > 0) {
                    requestForms = requestForms.filter(form => form.formId !== currentForm.formId)
                }
                setActiveForms(requestForms)
                setCurrentActiveForms(requestForms)
            }
        }
        showLoader(false, { lock: false });

    }

    useEffect(() => {
        if (requestId !== "new") {
            getRequestDetail();
        }
    }, [requestId])

    const fetchWorkflowForms = async (defaultNode) => {
        let response = await getSpaceAllFormsByWorkflowId(workflowId)

        if (response.status !== 200 || response.data?.length === 0) {
            message.error(t('No forms available'))
            showLoader(false)
            setSpaceForms([])
            return;
        }
        let currentForms = response.data || []
        setSpaceForms(currentForms)

        let requesterForm = currentForms.find(form => form.nodeId === defaultNode.id)
        if (currentForms.length > 0 && mode === "submission") {
            setCurrentActiveForm(requesterForm)
            setActiveForms([requesterForm])
            return
        }
    }

    const fetchFormConditions = async () => {
        let response = await getAllFormConditionForWorkflow(workflowId);
        if (response.status === 200) {
            setFormConditions(response.data)
        } else {
            setFormConditions([])
        }
        setFormConditionsLoaded(true)
    }

    const fetchNodeConditions = async () => {
        let response = await getWorkflowConditions(workflowId);
        if (response.status === 200) {
            setWorkflowConditions(response.data)
        } else {
            setWorkflowConditions([])
        }
        setWorkflowConditionsLoaded(true)
    }

    const getWorkflow = async () => {
        const response = await getSpaceWorkflow(spaceId);
        if (response.status === 200) {
            setWorkflowData(response?.data)
            if (response?.data?.node?.length) {
                let defaultNode = response.data.node.find(node => node.type === "default")
                setCurrentStatus(defaultNode?.id)
                setRequesterNode(defaultNode || {})
                await fetchWorkflowForms(defaultNode);
                let workflowHasDuplicateCheck = response.data.node.find(node => node?.data?.type === "duplicateCheck")
                setCheckDuplicate(workflowHasDuplicateCheck ? true : false)
            }
            setWorkflowLoaded(true)
        } else {
            showLoader(false)
        }
    }

    const fetchSpaceNotificationTemplates = async () => {
        const notiResponse = await getSpaceNotification(spaceId)
        if (notiResponse?.data?.result?.length > 0) {
            setNotificationTemplates(notiResponse.data.result)
        }
    }

    const getIsCompleteMappingFromForms = (forms = []) => {
        const allForms = Array.isArray(forms) ? forms : []

        const stack = []
        allForms.forEach((form) => {
            const items = Array.isArray(form?.items) ? form.items : []
            stack.push(...items)
        })

        while (stack.length > 0) {
            const item = stack.shift()
            if (!item || typeof item !== "object") {
                continue
            }

            if (Array.isArray(item.children) && item.children.length > 0) {
                stack.push(...item.children)
            }

            if (item.formType !== "tableForm" || !Array.isArray(item.columns)) {
                continue
            }

            const completeColumn = item.columns.find((col) => col?.isComplete === true)
            if (!completeColumn) {
                continue
            }

            return {
                dataId: completeColumn?.parentTable || "",
                columnId: completeColumn?.mappedColumn || completeColumn?.id || "",
            }
        }

        return null
    }

    // True when the current form(s) being submitted have scoring-enabled fields
    // and the request hasn't been scored yet — used to flag the backend to
    // (re)calculate the assessment score. Upcoming forms are ignored and it
    // never applies to drafts.
    const shouldCalculateScore = (status, formsToScan = []) => {
        if (status === "draft") return false
        if (defaultRequestDetail.assessmentScore) return false
        return (Array.isArray(formsToScan) ? formsToScan : []).some(
            (form) => getAllWidgets(form?.items || []).some((widget) => widget.enableScoring)
        )
    }

    useEffect(() => {
        if (workflowId && requestId === "new") {
            getWorkflow();
            fetchNodeConditions()
            fetchFormConditions();
        }
    }, [workflowId])

    useEffect(() => {
        if (requestId !== "new") return
        if (draftAutoSaved) return
        if (!workflowLoaded || !formConditionsLoaded || !workflowConditionsLoaded) return
        if (!workflowData?.node?.length) return
        if (!requesterNode?.id) return
        if (!spaceForms?.length) return

        handleDraftClick()
        setDraftAutoSaved(true)
    }, [
        requestId,
        draftAutoSaved,
        workflowLoaded,
        formConditionsLoaded,
        workflowConditionsLoaded,
        workflowData?.node?.length,
        requesterNode?.id,
        spaceForms?.length
    ])

    useEffect(() => {
        if (spaceId) {
            fetchSpaceNotificationTemplates()
        }
    }, [spaceId])

    useEffect(() => {
        const fetchMasterList = async () => {
            const response = await getMasterList()
            if (response.status === 200 && Array.isArray(response.data)) {
                dispatch(setMasterListRedux(response.data))
            } else {
                dispatch(setMasterListRedux([]))
            }
        }
        fetchMasterList()
    }, [dispatch])

    const submitRequest = async (formValues, status = "submit", isDraft = false) => {
        // status = selectedDuplicateData ? "closed" : "submit"
        const generation = ++saveGenerationRef.current
        setDocIsSubmitting(true)
        let nextStep = {}, activityLogs = defaultRequestDetail.activityLogs || [], workflow = [], nextNotifyTo = { user: [], group: [], role: [], userPicker: [] }, nextApprovers = { user: [], group: [], role: [], userPicker: [] };
        let skippedSteps = [], approvalStatus = "", nextOutlookEventInfoNode = null;
        let currentStepEdge = workflowData?.edge?.find(edge => edge.source === requesterNode.id);
        let formItems = [];
        activeForms.map(form => {
            formItems = formItems.concat(form.items)
        })
        // This step stores visible fields (empty included) and hidden fields a
        // condition sets. Other hidden fields stay off formValues so they are
        // not frozen when they appear on a later step.
        let currentValues = getStepFormValues(formItems, { ...formValues }, userInfo, userGroups, currentStatus, formConditions)
        let formWidgetList = getVisibleWidgets(formItems, { ...formValues }, userInfo, userGroups, currentStatus, formConditions, undefined, { preserveHiddenValues: true })

        if (currentStepEdge && status !== "draft") {
            let sortedNodes = sortNodesByEdges(workflowData.node, workflowData.edge)
            let nextNodes = sortedNodes.filter(node => node.type !== "default")
            let nextStepNode = {}
            let foundNextStep = false
            // nextNodes.find(node => node.id === currentStepEdge.target)
            for (const node of nextNodes) {
                nextStepNode = { ...node }
                if (nextStepNode?.data?.type === "outlookCalendar") {
                    nextOutlookEventInfoNode = { ...nextStepNode }
                }
                if (node.type !== "textInput") {
                    continue;
                }
                nextApprovers = { user: [], group: [], role: [], userPicker: [] }
                if (nextStepNode.data.approverType === "default") {
                    nextApprovers = getRequestApprovers(nextStepNode.data.assignTo, formValues, spaceSpecificUsers, spaceSpecificGroups)
                } else if (nextStepNode.data?.approverType === "conditional") {
                    let conditions = workflowConditions.filter(condition => condition.nodeId === node.id)
                    if (conditions.length > 0) {
                        let conditionStatus = nodeConditionsHandler(conditions, formValues, [...formItems, ...(currentActiveForm?.items || [])])
                        if (conditionStatus?.length > 0) {
                            conditionStatus.map(condition => {
                                let curApprovers = getRequestApprovers(condition.approvers, formValues, spaceSpecificUsers, spaceSpecificGroups)
                                for (const key in curApprovers) {
                                    nextApprovers[key] = Array.from(new Set([...nextApprovers[key], ...curApprovers[key]]))
                                }
                            })
                        }
                    }
                }
                if (isObjectEmpty(nextApprovers, ["user", "group"])) {
                    skippedSteps.push(buildSkippedStepData(nextStepNode))
                    continue;
                } else {
                    foundNextStep = true
                    break;
                }
            }

            if (foundNextStep && nextStepNode?.type === "textInput") {
                nextStep = nextStepNode
            } else {
                // Every remaining approval step was skipped (or there were none).
                // Keep those skipped rows and land on the end node.
                const endNode = nextNodes.find(node => node?.data?.type === "end")
                    || sortedNodes.find(node => node?.data?.type === "end")
                if (endNode) {
                    approvalStatus = "approved"
                    nextStep = endNode
                    nextApprovers = { user: [], group: [], role: [], userPicker: [] }
                }
            }
        }

        let postData = { ...defaultRequestDetail, createdOn: moment().utc(), createdBy: defaultRequestDetail?.createdBy?.email ? defaultRequestDetail.createdBy : { id: userInfo.userId, name: userInfo.name, email: userInfo.email }, currentCycle: defaultRequestDetail.currentCycle || "1", spaceId: spaceId, workflowId: workflowId, status: "", value: { ...defaultRequestDetail.value, ...formValues }, dueDate: "" }
        if (nextStep?.data && status !== "draft") {
            if (nextStep.data?.deadline) {
                postData.dueDate = getDueDate(nextStep)
            }
            postData.status = nextStep.data?.name
            if (nextStep?.data?.notifyTo) {
                nextNotifyTo = getRequestApprovers(nextStep?.data.notifyTo, formValues, spaceSpecificUsers, spaceSpecificGroups)
            }
            postData.approvers = { ...nextApprovers }
        }
        let activityMessage = `${userInfo.name} has raised a request`;
        if (isDraft) {
            postData.dueDate = ""
            postData.approvers = { user: [], group: [], role: [], userPicker: [] }
            postData.status = "draft"
            activityMessage = `${userInfo.name} has submitted a request in draft`
            workflow = []
            postData.value = { ...formValues }
            let defaultValues = { ...formValues }
            activeForms.map(form => {
                if (form.defaultValues) {
                    defaultValues = { ...defaultValues, ...formValues }
                }
            })
            postData.value = { ...defaultValues }
        }
        if (postData.currentCycle !== "1") {
            activityMessage = `${userInfo.name} has submitted the request for cycle ${defaultRequestDetail.currentCycle}`
        }
        activityLogs = activityLogs.concat({ "message": activityMessage, updatedOn: moment().utc(), updatedBy: userInfo.email })
        postData.activityLogs = activityLogs
        if (!isDraft) {
            let reqStepData = { formValues: { ...currentValues }, ...requesterNode.data, dueDate: "", comment: "", name: requesterNode.data.name, count: requesterNode.data?.count, approvalStep: requesterNode.data?.approvalStep, period: requesterNode.data?.period, assignTo: requesterNode.data?.assignTo, formId: requesterNode.formData?.formId, approvalStatus: "submitted", delayed: false, actionBy: userInfo.email, actionOn: moment().utc(), type: "default" }
            workflow.push(reqStepData)
            if (approvalStatus === "approved") {
                // Every remaining approval step was skipped, so the request lands
                // straight on the end node. Keep the skipped rows before it.
                workflow = workflow.concat([...skippedSteps])
                let approvalStepData = { ...nextStep?.data, approvalStatus: "approved" }
                postData.approvers = { user: [], group: [], role: [], userPicker: [] }
                workflow.push(approvalStepData)
                postData.status = approvalStepData.name

            } else if (status !== "closed" && nextStep?.type === "textInput") {
                workflow = workflow.concat([...skippedSteps])
                let nextStepData = {
                    formValues: {},
                    ...nextStep.data,
                    dueDate: postData.dueDate,
                    comment: "",
                    name: postData.status,
                    deadline: nextStep.data?.deadline,
                    count: nextStep.data?.count,
                    approvalStep: nextStep.data?.approvalStep,
                    period: nextStep.data?.period,
                    assignTo: nextApprovers,
                    notifyTo: nextNotifyTo,
                    formId: nextStep.formData?.formId,
                    approvalStatus: "pending",
                    actionBy: "",
                    actionOn: "",
                    delayed: approvalDelayed(requestDetail.dueDate),
                    // delegatedUser: ""
                    // getDelegatedUser(userInfo, postData.approvers, spaceSpecificUsers)
                }
                workflow.push(nextStepData)
            }

        }
        postData["workflow"] = workflow
        postData["originalWorkflow"] = { nodes: workflowData.node, edges: workflowData.edge }
        postData["formConditions"] = [...formConditions]
        postData["workflowForms"] = [...spaceForms]
        postData["workflowConditions"] = [...workflowConditions]

        if (shouldCalculateScore(postData.status, activeForms)) {
            postData.calculateScore = true
        }

        const isCompleteMapping = getIsCompleteMappingFromForms(spaceForms)
        if (isCompleteMapping) {
            postData.isComplete = isCompleteMapping
        } else {
            delete postData.isComplete
        }

        if (nextOutlookEventInfoNode) {
            try {
                let outlookMeetingItems = createOutlookEventData(nextOutlookEventInfoNode.data.outlookEventInfo || {}, postData.value, formWidgetList)
                postData.outlookEventData = outlookMeetingItems
            } catch (err) {
                message.error(err.message || "Invalid meeting date/time. Please fix and try again.")
                setDocIsSubmitting(false)
                showLoader(false, { lock: false })
                return
            }
        }
        // return
        let valueToBeSubmitted = formatPostValue(postData.value)
        valueToBeSubmitted = trimStringValues(valueToBeSubmitted)
        postData.value = { ...valueToBeSubmitted }
        showLoader(true, { lock: true })
        let postResponse = await submitRequestForm({...postData, spaceName: spaceData.name})
        if (requestId !== "new") {
            showLoader(false, { lock: false })
        }
        setDocIsSubmitting(false)

        if (postResponse.status === 200) {

            if (generation === saveGenerationRef.current) {
                setRequestDetail({ status: postData.status, currentCycle: postData.currentCycle, value: { ...postData.value } })
                setDefaultRequestDetail({ ...postResponse.data })
            }
            let companyIdentifier = getStoredCompanyIdentifier()

            let modInformation = {
                ...postData.value,
                "Recipient": "[Recipient]",
                "Chatroom name": "",
                "Chatroom message sender": "",
                "Space name": spaceData?.name,
                "Request Id": postResponse.data?.caseId,
                spaceId: spaceId,
                redirectUrl: `/${companyIdentifier}/app/space/${spaceId}/approve/${workflowId}/${postResponse.data?.requestId}`,
                "Due date": postData.dueDate,
                "Workflow step": postData?.status
            }
            if (postData.status === "draft" && requestId === "new") {
                setTimeout(() => {
                    let url = modInformation.redirectUrl
                    if(requestFromMobile) {
                        url += "?type=mobile"
                    }
                    navigate(url, { replace: true })
                    setCurrentRequestId(postResponse.data?.requestId)
                }, [100])
            }
            if (postData.status !== "draft" && postData.status !== "closed") {
                setMessageState(true)

                let reqTemplate = notificationTemplates.find(notification => notification.notificationType === "WORKFLOW_STEP_WAITING")
                if (postData.dueDate) {
                    reqTemplate = notificationTemplates.find(notification => notification.notificationType === "WORKFLOW_STEP_WAITING_WITH_DUE_DATE")
                }
                // TRIGGER END NOTIFICATION
                let endNode = workflowData?.node?.find(step => step?.data?.type === "end")

                if (postData.status === endNode?.data?.name) {
                    reqTemplate = notificationTemplates.find(notification => notification.notificationType === "WORKFLOW_END_NOTIFICATION")
                    let approvedNotifiedUsers = getRequestApprovers(endNode?.data?.notifyTo || {}, postData.value, spaceSpecificUsers, spaceSpecificGroups)

                    if (reqTemplate?.enabled) {
                        triggerNotification({
                            recipients: { user: approvedNotifiedUsers?.user ? [...approvedNotifiedUsers.user] : [], group: approvedNotifiedUsers?.group ? [...approvedNotifiedUsers.group] : [] },
                            notificationParams: modInformation,
                            template: reqTemplate,
                            userInfo: userInfo,
                            currentStepInfo: nextStep,
                            spaceSpecificGroups: spaceSpecificGroups,
                            spaceSpecificUsers: spaceSpecificUsers,
                            formItems: formWidgetList
                        })
                    }
                } else {
                    // The waiting mail only goes out when the step the request moved
                    // to is an approval step; a plain submit step has nothing to approve.
                    if (reqTemplate?.enabled && canSendStepWaitingNotification(reqTemplate, nextStep)) {
                        let uniqueApprovers = getRequestApprovers(postData.approvers, postData.value, spaceSpecificUsers, spaceSpecificGroups)
                        triggerNotification({
                            recipients: uniqueApprovers,
                            notificationParams: modInformation,
                            template: reqTemplate,
                            userInfo: userInfo,
                            currentStepInfo: nextStep,
                            spaceSpecificGroups: spaceSpecificGroups,
                            spaceSpecificUsers: spaceSpecificUsers,
                            formItems: formWidgetList
                        })
                    }
                    let notificationTemplateForNotified = notificationTemplates.find(notification => notification.notificationType === "WORKFLOW_STEP_NOTIFICATION")
                    if (notificationTemplateForNotified?.enabled) {
                        let nextNotifyTo = workflow[workflow.length - 1]?.notifyTo || { user: [], group: [] }
                        let uniqueNotifiedUsers = getRequestApprovers(nextNotifyTo, postData.value, spaceSpecificUsers, spaceSpecificGroups)
                        triggerNotification({
                            recipients: uniqueNotifiedUsers,
                            notificationParams: modInformation,
                            template: notificationTemplateForNotified,
                            userInfo: userInfo,
                            currentStepInfo: nextStep,
                            spaceSpecificGroups: spaceSpecificGroups,
                            spaceSpecificUsers: spaceSpecificUsers,
                            formItems: formWidgetList

                        })
                    }
                }
            }
        } else {
            message.error(t('Error in submitting the request. Please try again.'))
        }

    }

    const handleSubmit = async () => {
        try {
            await requestForm.validateFields();
        } catch {
            message.error(t('Please fill all required fields before submitting.'))
            return;
        }
        if (okToProceed) {
            setIsSubmitted(true)
            return
        }
        if (checkDuplicate) {
            handleDuplicateCheck(true)
        } else {
            setIsSubmitted(true)

        }
    }

    const handleCycleChange = (cycle) => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

        if (cycle === Number(defaultRequestDetail.currentCycle)) {
            setRequestDetail({ ...defaultRequestDetail })
            setActiveForms(currentActiveForms)
        } else {
            let reqWorkflow = defaultRequestDetail?.logs[cycle - 1]
            let logValues = {}
            for (let i = 0; i < reqWorkflow.length - 1; i++) {
                let curStepValues = reqWorkflow[i].formValues || {}
                logValues = { ...logValues, ...curStepValues }
            }
            let reqDetails = { ...defaultRequestDetail, workflow: reqWorkflow, currentCycle: cycle, value: logValues }
            setRequestDetail({ ...reqDetails })
            let currentForms = []
            reqWorkflow.map(step => {
                let formForStep = defaultRequestDetail?.workflowForms?.find(form => form.formId === step.formId)
                if (formForStep) {
                    currentForms.push(formForStep)
                }
            })
            setActiveForms(currentForms)
        }
    }

    const handleDraftClick = () => {
        submitRequest(currentValuesRef.current, "submit", true)
    }

    // Written synchronously so every handler (submit, draft, print, the lookups) always
    // reads the latest values; the state mirror exists only for the two render-side
    // readers and is updated at transition priority so a keystroke burst pays for it
    // once instead of re-rendering this 1700-line page per character.
    const passFormValues = useCallback((formValues) => {
        currentValuesRef.current = { ...currentValuesRef.current, ...formValues }
        startTransition(() => setCurrentValues(currentValuesRef.current))
    }, [])

    const handleDocAction = async (action = "save", comment = "") => {
        let postData = { ...defaultRequestDetail }
        if (action !== "save") {
            let currentStatus = archiveDeleteAction === "Archival" ? "archived" : "deleted"
            if (action === "restored") {
                if (defaultRequestDetail?.workflow?.length === 0) {
                    let defaultNode = workflowData.node.find(node => node.type === "default")
                    currentStatus = defaultNode?.data?.name
                } else {
                    let curWorkflow = defaultRequestDetail?.workflow
                    currentStatus = curWorkflow[curWorkflow.length - 1]?.name
                }
                if(defaultRequestDetail.archivedStep === "rejected") {
                    currentStatus = "rejected"
                }
                postData.status = currentStatus
            } else {
                postData.status = currentStatus
                if (action === "archived") {
                    postData.archivalComment = comment
                } else if (action === "deleted") {
                    postData.deletionComment = comment
                }
                postData.archivedStep = defaultRequestDetail?.status
            }
        }
        showLoader(true)
        let postResponse = await submitRequestForm(postData)
        showLoader(false)
        if (postResponse.status === 200) {
            let messageStatus = action === "save" ? "saved" : action
            message.success("Request " + messageStatus + " successfully.")
            handleArchiveDeleteClose();
            setRequestDetail({ ...postResponse.data })
            setDefaultRequestDetail({ ...postResponse.data })
            // If the request is deleted, navigate back to the documents list
            if (action === "deleted") {
                setTimeout(() => {
                    navigate(`/app/space/${spaceId}/documents`)
                }, 600) // slight delay so user can see the toast
            }
            if (action === "archived" || action === "deleted") {
                let formItems = [];
                activeForms.map(form => {
                    formItems = formItems.concat(form.items)
                })
                let formWidgetList = getVisibleWidgets(formItems, { ...postData.value }, userInfo, userGroups, currentStatus, formConditions)

                let archivedTemplates = notificationTemplates.find(notification => notification.notificationType === "DOCUMENT_ARCHIVED")
                let deletedTemplates = notificationTemplates.find(notification => notification.notificationType === "DOCUMENT_DELETED")
                let templateToUse = action === "archived" ? archivedTemplates : deletedTemplates
                if (templateToUse?.enabled) {
                    let companyIdentifier = getStoredCompanyIdentifier()

                    let modInformation = {
                        ...postData.value,
                        "Recipient": "",
                        "Chatroom name": "",
                        "Chatroom message sender": "",
                        "Space name": spaceData?.name,
                        "Request Id": requestDetail.caseId,
                        "spaceId": spaceId,
                        "redirectUrl": `/${companyIdentifier}/app/space/${spaceId}/approve/${workflowId}/${postData.requestId}`,
                        "Last comment": comment || "",
                        "Last updater": userInfo.name,
                        "Due date": requestDetail?.dueDate,
                        "Workflow step": requestDetail?.status,
                    }
                    triggerNotification({
                        recipients: { user: [requestDetail?.createdBy?.email], group: [] },
                        notificationParams: modInformation,
                        template: templateToUse,
                        userInfo: userInfo,
                        spaceSpecificGroups: spaceSpecificGroups,
                        spaceSpecificUsers: spaceSpecificUsers,
                        formItems: formWidgetList
                    })
                }
            }
        }
    }

    const handleCopyRequest = async () => {
        showLoader(true)
        let postData = { currentCycle: "1", workflow: [], status: "draft", dueDate: "", approvers: {}, activityLogs: [{ "message": `${userInfo.name} has submitted a request in draft`, updatedOn: moment().utc(), updatedBy: userInfo.email }], createdBy: { id: userInfo.userId, name: userInfo.name, email: userInfo.email }, spaceId: spaceId, workflowId: workflowId, originalWorkflow: { ...defaultRequestDetail.originalWorkflow }, workflowConditions: defaultRequestDetail.workflowConditions || [], formConditions: defaultRequestDetail.formConditions ? [...defaultRequestDetail.formConditions] : [], workflowForms: [...defaultRequestDetail.workflowForms], value: {} }
        let currentValue = { ...defaultRequestDetail.workflow[0]?.formValues }
        let value = {};

        const imageExtensions = new Set(["jpg", "jpeg", "png", "gif", "bmp", "tiff", "tif", "webp", "svg"]);

        const isImageFileName = (val) => {
            if (typeof val !== "string") return false;
            const normalized = val.split("?")[0].split("#")[0].replace(/\\/g, "/");
            const name = normalized.split("/").pop() || "";
            const ext = name.split(".").pop()?.toLowerCase();
            return !!ext && imageExtensions.has(ext);
        };

        Object.keys(currentValue).forEach(key => {
            const val = currentValue[key];
            if (val?.file) return;
            if (isImageFileName(val)) return;
            value = { ...value, [key]: val };
        });
        let valueToBeSubmitted = formatPostValue(value)
        valueToBeSubmitted = trimStringValues(valueToBeSubmitted)

        postData.value = { ...valueToBeSubmitted }
        let response = await submitRequestForm(postData)
        showLoader(false)
        if (response.status === 200) {
            message.success(t('Request copied successfully.'))
            let url = `/app/space/${spaceId}/approve/${workflowId}/${response.data?.requestId}`
            setTimeout(() => {
                navigate(url)
            }, 1000)
        }
    }

    const openArchiveDeleteModal = (action) => {
        setArchiveDeleteModal(true)
        setArchiveDeleteAction(action)
    }

    const submitDeleteArchiveForm = async (values) => {
        let currentStatus = archiveDeleteAction === "Archival" ? "archived" : "deleted"
        handleDocAction(currentStatus, values.comment?.trim())
    }

    const handleArchiveDeleteClose = () => {
        setArchiveDeleteAction("")
        setArchiveDeleteModal(false)
        commentForm.resetFields()
    }

    const handleDocSave = async () => {
        const latestValues = currentValuesRef.current
        const generation = ++saveGenerationRef.current
        let postData = { ...defaultRequestDetail, value: { ...defaultRequestDetail.value, ...latestValues } }
        let allActiveForms = [...activeForms], formItems = [];
        if (currentActiveForm?.formId) {
            allActiveForms.push(currentActiveForm)
        }
        allActiveForms.map(form => {
            formItems = formItems.concat(form.items)
        })
        const existingValues = { ...defaultRequestDetail.value }
        const combinedValues = { ...existingValues, ...latestValues }
        let modCurrentValues = getDifferenceValues(formItems, combinedValues, userInfo, userGroups, currentStatus, formConditions, existingValues)

        postData.value = trimStringValues(formatPostValue({ ...existingValues, ...latestValues }))
        let updatedWorkflow = [...postData.workflow]
        updatedWorkflow = updatedWorkflow.map(step => {
            if (step.name === postData.status) {
                return { ...step, formValues: { ...(step.formValues || {}), ...modCurrentValues } }
            }
            return { ...step }
        })
        postData.workflow = updatedWorkflow
        let activityLogs = postData.activityLogs || []
        activityLogs.push({message: `${userInfo.name} has saved the request in ${postData.status}.`, updatedOn: moment().utc(), updatedBy: userInfo.email})
        postData.activityLogs = activityLogs
        if (shouldCalculateScore(postData.status, allActiveForms)) {
            postData.calculateScore = true
        }
        showLoader(true)
        let postResponse = await submitRequestForm(postData)
        showLoader(false)
        if (postResponse.status === 200) {
            message.success(t('Request saved'))
            if (generation === saveGenerationRef.current) {
                setRequestDetail({ ...postResponse.data })
                setDefaultRequestDetail({ ...postResponse.data })
            }
        } else {
            message.error(t('Failed to save. Please try again.'))
        }
    }

    const handleRequesterSave = async () => {
        const latestValues = currentValuesRef.current
        const generation = ++saveGenerationRef.current
        let postData = { ...defaultRequestDetail, value: formatPostValue({ ...defaultRequestDetail.value, ...latestValues }) }
        postData.activityLogs = postData.activityLogs || []
        postData.activityLogs.push({ "message": `${userInfo.name} has updated the request details`, updatedOn: moment().utc(), updatedBy: userInfo.email })
        if (shouldCalculateScore(postData.status, [currentActiveForm])) {
            postData.calculateScore = true
        }
        showLoader(true)
        let postResponse = await submitRequestForm(postData)
        showLoader(false)
        if (postResponse.status === 200) {
            message.success(t('Request updated'))
            if (generation === saveGenerationRef.current) {
                setRequestDetail({ ...postResponse.data })
                setDefaultRequestDetail({ ...postResponse.data })
            }
        } else {
            message.error(t('Failed to update. Please try again.'))
        }
    }

    const downloadXml = async () => {
        showLoader(true)
        let xmlResponse = await downloadRequestXml(defaultRequestDetail?.requestId, userInfo.userId)
        showLoader(false)
        if (xmlResponse.status === 200) {
            const blob = new Blob([xmlResponse.data], { type: 'text/xml' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = 'file.xml'; // Set the desired file name
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }

    const handleDuplicateCheck = async (isSubmitted = false) => {

        // if (duplicatesList?.length > 0) {
        //     setShowDuplicateCheckModal(true)
        //     return;
        // }
        let mappedFields = [];
        let duplicateNode = workflowData?.node?.find(node => node.data?.type === "duplicateCheck")
        if (duplicateNode && duplicateNode.data && duplicateNode.data.sapIntegrationInfo) {
            mappedFields = duplicateNode.data.sapIntegrationInfo || []
        }
        let duplicateCheckPost = {}
        mappedFields.forEach(field => {
            duplicateCheckPost[field.source] = currentValues ? currentValues[field.target] : null
        })
        showLoader(true)
        let duplicateResponse = await getDuplicateCheckList(duplicateCheckPost)
        showLoader(false)
        setDuplicatesList(duplicateResponse.data || [])
        let duplicatesData = duplicateResponse?.data || []
        let fields = duplicatesData[0] ? Object.keys(duplicatesData[0].fields) : []
        fields = fields.map(field => {
            return { title: field, dataIndex: field }
        })
        setDuplicateColumns([...fields, { title: t('Match %'), dataIndex: 'overall_confidence', render: (text) => <span>{text}%</span> }])
        let values = []
        values = duplicatesData?.map(data => {
            return { ...data.document, overall_confidence: data.overall_confidence }
        })
        setDuplicateValues(values)
        if (duplicatesData?.length > 0 && isSubmitted) {
            setIsSubmitted(false)
        }
        setShowDuplicateCheckModal(true)

    }

    const handleDuplicateModalClose = () => {
        setShowDuplicateCheckModal(false)
        setSelectedDuplicateData(null)
        setOkToProcess(true)
    }

    const handleDuplicateSelection = (item) => {
        if (selectedDuplicateData && selectedDuplicateData._id === item._id) {
            setSelectedDuplicateData(null)
            return
        }
        if (requestId === "new" || defaultRequestDetail?.status === "draft") {
            setSelectedDuplicateData({ ...item })
        }
    }

    const handleDuplicateSubmit = () => {
        setOkToProcess(true)
        // setRequestDetail({ ...requestDetail, value: { ...newValues } })
        setShowDuplicateCheckModal(false)
    }

    // Print builds its own two-column document (forms left, workflow right) from the
    // form definitions and values rather than printing the live screen, which cut
    // inputs in half and dropped whatever was scrolled out of view.
    const getPrintWorkflowSteps = () => {
        const nodes = workflowData?.node || []
        const steps = requestDetail?.workflow || []
        if (steps.length === 0) {
            const defaultNode = nodes.find(node => node.type === "default")
            return defaultNode?.data ? [{ ...defaultNode.data }] : []
        }
        // Same merge the on-screen workflow does: step progress over node config.
        return steps.map(step => {
            const node = nodes.find(item => item.data?.name?.toLowerCase() === String(step.name || "").toLowerCase())
            return node ? { ...node.data, ...step } : { ...step }
        })
    }

    const handlePrint = () => {
        const printValues = (currentValues && Object.keys(currentValues).length > 0)
            ? currentValues
            : (defaultRequestDetail?.value || {})

        printRequestDocument({
            forms: activeForms,
            values: printValues,
            workflow: getPrintWorkflowSteps(),
            conditions: formConditions,
            currentStatus,
            lng: i18n.language,
            userInfo,
            userGroups,
            masterList,
            meta: {
                title: spaceData?.name || "Request",
                caseId: defaultRequestDetail?.caseId || "",
                status: defaultRequestDetail?.status || "",
                createdBy: defaultRequestDetail?.createdBy?.name || "",
                createdOn: defaultRequestDetail?.createdOn || "",
                cycle: requestDetail?.currentCycle || "",
            },
            submitterName: defaultRequestDetail?.createdBy?.name || userInfo.name || "",
        })
    }

    const closeRequest = async () => {
        let postData = { ...defaultRequestDetail, value: { ...currentValues }, status: "closed" }
        let activityLogs = defaultRequestDetail.activityLogs || [{ "message": `${userInfo.name} has closed the request`, updatedOn: moment().utc(), updatedBy: userInfo.email }]
        postData.activityLogs = activityLogs
        showLoader(true)
        let workflow = []
        let reqStepData = { formValues: { ...currentValues }, ...requesterNode.data, dueDate: "", comment: "", name: requesterNode.data.name, count: requesterNode.data?.count, approvalStep: requesterNode.data?.approvalStep, period: requesterNode.data?.period, assignTo: requesterNode.data?.assignTo, formId: requesterNode.formData?.formId, approvalStatus: "closed", delayed: false, actionBy: userInfo.email, actionOn: moment().utc(), type: "default" }
        workflow.push(reqStepData)
        postData["workflow"] = workflow
        postData["originalWorkflow"] = { nodes: workflowData.node, edges: workflowData.edge }
        postData["formConditions"] = [...formConditions]
        postData["workflowForms"] = [...spaceForms]
        postData["workflowConditions"] = [...workflowConditions]
        let postResponse = await submitRequestForm(postData)
        showLoader(false)
        if (postResponse.status === 200) {
            setRequestDetail({ ...requestDetail, status: "closed" })
            setMessageState(true)
        }
    }

    return (
        <div className="user-requests" style={{ '--header-offset': `${headerOffset}px`, '--request-details-top': `${requestDetailsTop}px` }}>
            <Flex className="request-header" justify="space-between" align="center">

                <BreadCrumb items={breadcrumbs} marginb="0px" />

                {(() => {
                    const actionButtons = (
                        <>
                            {
                                !isMobileView && defaultRequestDetail?.status === approvedStatus ?
                                    <Button onClick={() => downloadXml()} style={{ color: "#141BCB", borderColor: "#141BCB" }}><DownloadOutlined /> {t('Download XML')}</Button>
                                    : null
                            }
                            {
                                !isMobileView ?
                                    <Button onClick={handlePrint}><PrinterOutlined /> {t('Print')}</Button>
                                    : null
                            }

                            {
                                defaultRequestDetail?.assessmentScore ?
                                    <Button onClick={() => setShowScoreModal(true)} style={{ color: "#141BCB", borderColor: "#141BCB" }}><TrophyOutlined /> {t('Score')}</Button>
                                    : null
                            }

                            {
                                requestId !== "new" && (
                                    <>
                                        {
                                            (isCurrentSpaceAdmin ||
                                                (
                                                    spaceEntitlements.includes("Workflow_Documents_Delete") &&
                                                    defaultRequestDetail?.createdBy?.email === userInfo.email
                                                )) &&
                                            <Button danger onClick={() => openArchiveDeleteModal("Deletion")} ><DeleteOutlined /> {t('Delete')}</Button>
                                        }
                                        {
                                            (isCurrentSpaceAdmin || (spaceEntitlements.includes("Workflow_Documents_Delete") && defaultRequestDetail?.createdBy?.email === userInfo.email)) && defaultRequestDetail?.status !== "archived" &&
                                            <Button onClick={() => openArchiveDeleteModal("Archival")} ><InboxOutlined /> {t('Archive')}</Button>
                                        }
                                    </>
                                )
                            }
                            {
                                checkDuplicate && requestId !== "new" && defaultRequestDetail?.status !== "draft" ?
                                    <Button onClick={handleDuplicateCheck}>{t('Duplicates')}</Button>
                                    : null
                            }

                            {
                                showApprovalTab && !approvedStatus && !showRequesterSaveButton && !hasSubmittedCurrentStep && <Button className="success-button" id="saveButton" disabled={requestDetail.currentCycle !== defaultRequestDetail.currentCycle} onClick={handleDocSave}>{t('Save')}</Button>
                            }

                            {(defaultRequestDetail?.status == "archived" && (userInfo?.isAdmin || spaceEntitlements.includes("Workflow_Documents_Update") || isCurrentSpaceAdmin)) &&
                                <Button onClick={() => handleDocAction("restored")}>
                                    <ReloadOutlined />
                                    {t('Restore')}
                                </Button>
                            }
                            {
                                (isCurrentSpaceAdmin ||
                                    (
                                        spaceEntitlements.includes("Workflow_Documents_Delete") &&
                                        defaultRequestDetail?.createdBy?.email === userInfo.email
                                    )) && spaceData.allowedDuplicate && approvedStatus ?
                                    <Button onClick={handleCopyRequest}>
                                        <CopyOutlined />
                                        {t('Copy Request')}
                                    </Button>
                                    : null
                            }
                            {
                                spaceEntitlements.includes("Workflow_Documents_Update") && showRequesterSaveButton ?
                                    <Button className="text-center" onClick={handleRequesterSave} disabled={requestDetail.currentCycle !== defaultRequestDetail.currentCycle} id="draftButton">{t('Save')}</Button>
                                    : null
                            }
                            {
                                (requestId === "new" || defaultRequestDetail?.status === "draft") && ((userInfo.isAdmin || (spaceEntitlements.includes("Workflow_Documents_Create") && defaultRequestDetail?.createdBy?.email === userInfo.email))) &&
                                <Button onClick={handleDraftClick} id="draftButton">{t('Save as draft')}</Button>
                            }

                            {
                                (requestId === "new" || defaultRequestDetail?.workflow?.length === 0) && (!hideApprovalStatus.includes(defaultRequestDetail?.status) || defaultRequestDetail?.status === "draft") && (Number(requestDetail.currentCycle)) && (userInfo.isAdmin || spaceEntitlements.includes("Workflow_Documents_Create")) &&
                                <>
                                    {
                                        checkDuplicate && okToProceed ?
                                            <Button onClick={handleDuplicateCheck}>{t('Duplicate Check')}</Button>
                                            : null
                                    }
                                    {
                                        (isCurrentSpaceAdmin || (spaceEntitlements.includes("Workflow_Documents_Update") && defaultRequestDetail?.createdBy?.email === userInfo.email)) ?
                                            <>
                                                {
                                                    checkDuplicate && selectedDuplicateData ?
                                                        (!isMobileView ? <Button className="success-button" onClick={closeRequest}>{t('Close Request')}</Button> : null)
                                                        :
                                                        <Button className="success-button" disabled={docIsSubmitting || (requestDetail.currentCycle !== defaultRequestDetail.currentCycle)} onClick={handleSubmit}>{t('Submit Request')}</Button>

                                                }
                                            </>
                                            : null
                                    }

                                </>
                            }
                        </>
                    )

                    if (isMobileView) {
                        return (
                            <Popover
                                trigger="click"
                                placement="bottomRight"
                                open={actionsPopoverOpen}
                                onOpenChange={setActionsPopoverOpen}
                                overlayClassName="request-actions-popover"
                                content={
                                    <Flex vertical gap={8} style={{padding: "8px"}} onClick={() => setActionsPopoverOpen(false)}>
                                        {actionButtons}
                                    </Flex>
                                }
                            >
                                <Button icon={<MoreOutlined />} aria-label="Actions" />
                            </Popover>
                        )
                    }

                    return <Flex gap={16}>{actionButtons}</Flex>
                })()}

            </Flex>
            <div className={`request-body ${isDetailsOpen ? "details-open" : "details-collapsed"}`}>
                <div className="request-form" style={{ background: spaceData.spaceColor ? spaceColorBgMapping[spaceData.spaceColor] : "#f5eeff" }}>
                    <RequestForm requestForm={requestForm} currentStatus={currentStatus} spaceData={spaceData} forms={activeForms} defaultRequestDetail={defaultRequestDetail} requestDetail={requestDetail} conditions={formConditions} isSubmitted={isSubmitted} submitRequest={submitRequest} setIsSubmitted={setIsSubmitted} passFormValues={passFormValues} spaceEntitlements={spaceEntitlements} disableAllFields={hasSubmittedCurrentStep} />
                </div>
                <div className="request-details">
                    <RequestDetails
                        forms={activeForms}
                        requestForm={requestForm}
                        currentStatus={currentStatus}
                        spaceData={spaceData}
                        currentActiveForm={currentActiveForm}
                        conditions={formConditions}
                        workflowConditions={workflowConditions}
                        workflowData={workflowData}
                        requestId={requestId}
                        requestDetail={requestDetail}
                        defaultRequestDetail={defaultRequestDetail}
                        handleCycleChange={handleCycleChange}
                        currentValues={currentValues}
                        notificationTemplates={notificationTemplates}
                        spaceId={spaceId}
                        workflowId={workflowId}
                        activeForms={activeForms}
                        spaceEntitlements={spaceEntitlements}
                        passFormValues={passFormValues}
                        getRequestDetail={getRequestDetail}
                        hideGooglePlacesResults={messageState}
                    />
                </div>
                <Button
                    className={`request-details-toggle ${isDetailsOpen ? "is-open" : ""}`}
                    type="default"
                    onClick={() => setIsDetailsOpen((prev) => !prev)}
                    aria-label={isDetailsOpen ? "Close right panel" : "Open right panel"}
                    title={isDetailsOpen ? "Close details" : "Open details"}
                    icon={
                        <span className="request-details-toggle-icon">
                            <span className="icon-desktop">{isDetailsOpen ? <ArrowRightOutlined /> : <ArrowLeftOutlined />}</span>
                            <span className="icon-mobile">{isDetailsOpen ? <ArrowDownOutlined /> : <ArrowUpOutlined />}</span>
                        </span>
                    }
                />
            </div>
            {
                messageState ?
                    <SubmitMessage state={messageState} message={requestDetail?.status === "draft" ? t("Your request has been saved in draft") : requestDetail.status === "closed" ? t("Your request has been closed successfully.") : t("Your request has been submitted successfully.")} spaceId={spaceId} requestDetail={requestDetail} />
                    : null
            }

            <Modal open={archiveDeleteModal} title={"Document " + archiveDeleteAction} onOk={handleArchiveDeleteClose} onCancel={handleArchiveDeleteClose}>
                <div className="deletion-modal">
                    {/* <div className="text-regular" style={{ marginBottom: "12px" }}>{archiveDeleteAction} Comment</div> */}
                    <Form form={commentForm} onFinish={submitDeleteArchiveForm} layout="vertical">
                        <Form.Item name="comment" label={archiveDeleteAction + " Comment"} rules={[{ required: true, whitespace: true, message: "Comment is required" }]}>
                            <TextArea style={{ width: "100%" }} />
                        </Form.Item>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "12px" }}>
                            <Button onClick={handleArchiveDeleteClose}>{t('Cancel')}</Button>
                            <Button danger htmlType="submit" className="success-button">{archiveDeleteAction === "Archival" ? "Archive" : "Delete"}</Button>
                        </div>
                    </Form>
                </div>
            </Modal>

            <Modal title={t('Duplicate Check Results')} className="duplicate-check-modal"
                open={showDuplicateCheckModal}
                onCancel={handleDuplicateModalClose}
                footer={null}
            // footer={

            //     <Button onClick={handleDuplicateModalClose}>Ignore</Button>

            // }
            >
                <div style={{ minWidth: 400, width: "fit-content" }}>
                    {
                        duplicatesList?.length > 0 ?
                            <>
                                <Table dataSource={duplicateValues} columns={duplicateColumns}
                                    onRow={(record, index) => ({
                                        onClick: () => handleDuplicateSelection({ ...record, index }),
                                        style: selectedDuplicateData?._id === record._id ? { backgroundColor: '#e6e6e6', cursor: 'pointer' } : { cursor: 'pointer' }
                                    })}
                                />
                            </>
                            : <div>{t('No duplicates found.')}</div>
                    }

                </div>
                {
                    selectedDuplicateData ?
                        <div className="my-2 flex justify-end gap-4">
                            <Button onClick={handleDuplicateModalClose}>{t('Ignore')}</Button>
                            <Button className="btn-primary" onClick={handleDuplicateSubmit}>{t('Use the data')}</Button>
                        </div>
                        : null
                }
            </Modal>

            <Modal title={t('Assessment Score')}
                open={showScoreModal}
                onCancel={() => setShowScoreModal(false)}
                footer={null}
                className="sap-field-mapping-modal"
            >
                <div style={{ maxHeight: "83vh", overflowY: "auto" }}>
                    <div
                        className="flex justify-between items-center mb-4"
                        style={{ padding: "10px 14px", background: "#f5eeff", borderRadius: 8 }}
                    >
                        <div className="font-semibold" style={{ fontSize: 18 }}>{t('Total Score Obtained')}</div>
                        <div className="font-semibold" style={{ color: "#141BCB", fontSize: 22 }}>
                            {defaultRequestDetail?.assessmentScore?.totalScoreObtained ?? 0} / {defaultRequestDetail?.assessmentScore?.maximumScore ?? 0}
                        </div>
                    </div>
                    {
                        (() => {
                            const rootSections = (defaultRequestDetail?.assessmentScore?.fieldWiseScore || [])
                                .filter((section) => (section.children || []).length > 0)
                            if (rootSections.length === 0) return <div>{t('No scored questions found.')}</div>

                            const spaceColor = spaceData.spaceColor || "#722ed1"

                            // Paint a matched section/question with the color picked on its
                            // "Highlight" action. Only conditions that reference a Score belong
                            // here - everything else highlights the live form instead. Such a
                            // condition can still mix in plain form-field checks alongside the
                            // score, so the submitted values go in with the field-wise scores.
                            const scoreFormItems = activeForms.flatMap(form => form.items || [])
                            const scoreLookup = flattenScoreTree(defaultRequestDetail?.assessmentScore?.fieldWiseScore || [])
                            const scoreFormValues = { ...defaultRequestDetail?.value, ...currentValues }
                            const scoreHighlightConditions = (formConditions || []).filter(isScoreBasedCondition)
                            const getHighlightColor = (id) => {
                                if (!id || scoreHighlightConditions.length === 0) return null
                                const actions = formConditionsHandler(scoreHighlightConditions, scoreFormValues, { id }, scoreFormItems, currentStatus, userInfo, userGroups, scoreLookup)
                                const highlightAction = getHighlightAction(actions)
                                return highlightAction ? highlightAction.value : null
                            }

                            const renderQuestion = (item, childIndex, questionNumber, total) => {
                                const options = item.options || []
                                const selectedOptions = item.selectedOptions || []
                                const highlightColor = getHighlightColor(item.questionId)
                                const highlightTextColor = highlightColor ? getContrastTextColor(highlightColor) : null
                                return (
                                    <div
                                        key={item.questionId || childIndex}
                                        className="flex justify-between gap-4"
                                        style={{
                                            borderBottom: childIndex < total - 1 ? "1px solid #f0f0f0" : "none",
                                            padding: highlightColor ? "12px 8px" : "12px 0",
                                            background: highlightColor || "transparent",
                                            borderRadius: highlightColor ? 6 : 0
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <div className="font-semibold" style={{ fontSize: 15, color: highlightTextColor || "inherit", fontWeight: highlightColor ? 600 : 400 }}>{questionNumber}. {item.question}</div>
                                            {
                                                options.length > 0 ?
                                                    <div style={{ marginTop: 6 }}>
                                                        {options.map((opt) => {
                                                            const selected = selectedOptions.includes(opt.value)
                                                            return (
                                                                <div
                                                                    key={opt.value}
                                                                    style={{
                                                                        padding: "4px 8px",
                                                                        borderRadius: 6,
                                                                        marginBottom: 4,
                                                                        marginLeft: 16,
                                                                        background: selected ? "#f5eeff" : "transparent",
                                                                        color: selected ? "#141BCB" : "#555",
                                                                        fontWeight: selected ? 600 : 400
                                                                    }}
                                                                >
                                                                    {opt.label}{selected ? " ✓" : ""}
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                        <div className="font-semibold" style={{ color: highlightTextColor || "#141BCB", whiteSpace: "nowrap", paddingRight: 12, fontSize: 15 }}>
                                            {item.scoreObtained ?? 0}
                                        </div>
                                    </div>
                                )
                            }

                            // Recursively render a section and its children — children may be
                            // nested sub-sections or questions. Nested sections use a thinner,
                            // lighter border than the top-level ones. Uses the same Collapse
                            // styling as the live form's section widget (PreviewSection.jsx)
                            // so the score panel matches the form's collapsible sections.
                            const renderSection = (section, depth, key) => {
                                const children = section.children || []
                                const isNested = depth > 0
                                const highlightColor = getHighlightColor(section.sectionId)
                                let questionNumber = 0
                                return (
                                    <Collapse
                                        key={key}
                                        bordered={false}
                                        collapsible="header"
                                        expandIconPosition="end"
                                        expandIcon={({ isActive }) => (
                                            <CaretLeftOutlined style={{ color: "#00000073" }} rotate={isActive ? 270 : 180} />
                                        )}
                                        style={{
                                            background: highlightColor || "#fff",
                                            borderRadius: isNested ? 12 : 20,
                                            border: isNested ? "1px solid #ececec" : "1px solid",
                                            borderColor: isNested ? "#ececec" : spaceColor,
                                            borderTop: isNested ? "1px solid #ececec" : "4px solid",
                                            borderTopColor: isNested ? "#ececec" : spaceColor,
                                            marginTop: isNested ? 12 : 0,
                                            marginBottom: isNested ? 0 : 20
                                        }}
                                    >
                                        <Collapse.Panel
                                            key="panel"
                                            header={
                                                <div style={{ fontSize: isNested ? 16 : 18, fontWeight: 600, color: highlightColor ? getContrastTextColor(highlightColor) : "#1f1f1f" }}>{section.label}</div>
                                            }
                                            extra={
                                                <div className="font-semibold" style={{ color: "#141BCB", whiteSpace: "nowrap", fontSize: isNested ? 14 : 16 }}>
                                                    {section.scoreObtained ?? 0} / {section.totalSectionScore ?? 0}
                                                </div>
                                            }
                                        >
                                            <Divider style={{ margin: "0 0 4px" }} />
                                            {children.map((child, childIndex) => {
                                                if (Array.isArray(child.children)) {
                                                    return renderSection(child, depth + 1, child.sectionId || `${key}-${childIndex}`)
                                                }
                                                questionNumber += 1
                                                return renderQuestion(child, childIndex, questionNumber, children.length)
                                            })}
                                        </Collapse.Panel>
                                    </Collapse>
                                )
                            }

                            return rootSections.map((section, sectionIndex) => renderSection(section, 0, section.sectionId || sectionIndex))
                        })()
                    }
                </div>
            </Modal>
        </div>
    )

}

export default Requests
